// extracted by mini-css-extract-plugin
export default {"root":"TLpfQ-YF8LCAHRVLWbc5w","headerText":"JIQuKN_5JBpWUZQZxXWRE","image":"_1CaGj6zv_zLvV4dwF7wzGq"};